import { toast } from "react-toastify";

export const handleApiError = (err, dispatch) => {
  if (err.response?.data?.detail === "Bearer token has expired") {
    toast.error("Your session has expired. Please log in again.");
    return "Session expired.";
  }

  const errorMessage =
    err.response?.data?.detail;
  toast.error(errorMessage);
  return errorMessage;
};

export const handleApiResponse = (response, dispatch) => {
  // Check for token expiration in a successful response
  if (response.data?.detail?.includes("Bearer") || response.data?.message?.includes("Bearer") ) {
    toast.error("Your session has expired. Please log in again.");
    return { error: "Session expired." };
  }
  
  // Handle other issues in the response
  if (response.data?.success === false) {
    const errorMessage = response.data?.message;
    toast.error(errorMessage);
    return { error: errorMessage };
  }

  return { data: response.data };
};
